module.exports = __webpack_public_path__ + "img/ac20bbe.jpg";